import React, { useState, useEffect } from 'react';
import api from '../api/client';

const btnGhost = { padding: '7px 12px', background: 'none', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#555' };
const btnDanger = { padding: '7px 12px', background: 'none', border: '1px solid #c0392b', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#c0392b' };

export default function SentContacts() {
  const [contacts, setContacts] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  const load = async () => {
    const { data } = await api.get('/campaigns/sent-contacts');
    setContacts(data);
  };
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    await api.delete(`/campaigns/sent-contacts/${id}`);
    await load();
  };

  const clearAll = async () => {
    if (!window.confirm('Очистить весь список? Этим номерам можно будет писать снова.')) return;
    setLoading(true);
    await api.delete('/campaigns/sent-contacts');
    await load();
    setLoading(false);
  };

  const filtered = contacts.filter(c =>
    c.phone.includes(search) ||
    (c.campaign_name || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ padding: 32 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 600, margin: 0 }}>База отправленных</h1>
          <div style={{ fontSize: 13, color: '#888', marginTop: 4 }}>Номера которым уже отправлялось сообщение</div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => { const txt = filtered.map(c => c.phone).join('\n'); navigator.clipboard.writeText(txt); }} style={btnGhost}>📋 Копировать все</button>
          <button onClick={clearAll} disabled={loading} style={btnDanger}>🗑 Очистить всё</button>
        </div>
      </div>

      <input
        placeholder="Поиск по номеру или рассылке..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{ width: '100%', padding: '9px 12px', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 14, marginBottom: 16, boxSizing: 'border-box', outline: 'none' }}
      />

      <div style={{ fontSize: 13, color: '#888', marginBottom: 12 }}>
        Всего: <b>{contacts.length}</b> · Показано: <b>{filtered.length}</b>
      </div>

      <div style={{ display: 'grid', gap: 6 }}>
        {filtered.map(c => (
          <div key={c.id} style={{ background: '#fff', border: '1px solid #e8e8e6', borderRadius: 8, padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontFamily: 'monospace', fontSize: 13, minWidth: 140 }}>{c.phone}</span>
            <span style={{ fontSize: 12, color: '#534AB7', minWidth: 160 }}>{c.campaign_name || '—'}</span>
            <span style={{ fontSize: 12, color: '#888', minWidth: 120 }}>{c.account_name || '—'}</span>
            <span style={{ fontSize: 12, color: '#aaa', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.message_text || '—'}</span>
            <span style={{ fontSize: 11, color: '#bbb', minWidth: 120, textAlign: 'right' }}>
              {c.sent_at ? new Date(c.sent_at).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—'}
            </span>
            <button onClick={() => del(c.id)} style={{ ...btnDanger, padding: '4px 8px', fontSize: 12 }}>✕</button>
          </div>
        ))}
        {filtered.length === 0 && (
          <div style={{ textAlign: 'center', padding: 60, color: '#aaa', fontSize: 14 }}>
            {contacts.length === 0 ? 'Список пуст — отправьте первую рассылку' : 'Ничего не найдено'}
          </div>
        )}
      </div>
    </div>
  );
}
